(() => {
    function closeCalendly()
    {
        let url = new URL(window.location)
        url.hash = url.hash.replace('#calendly', '')
        history.pushState({}, '', url)
    }

    function initCalendly() {
        Calendly.initPopupWidget({url: 'https://calendly.com/orthoclear?hide_gdpr_banner=1&primary_color=ef6199'})
        const calendlyCloseButton = document.querySelector('.calendly-popup-close')
        calendlyCloseButton.addEventListener('click', closeCalendly)
    }

    document.addEventListener('DOMContentLoaded', () => {
        const url = new URL(window.location)
        if(url.hash == '#calendly')
        {
          console.log("cale");
          
            initCalendly()
        }

        window.addEventListener('popstate', (e) => {
            const url = new URL(window.location)
            if(url.hash == '#calendly')
            {
                initCalendly()
            }
        })
    })
})()